/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { PaymentMethodResourceService } from '@well/company-libs/payment-method/data-access';
import { Observable } from 'rxjs';
import { JsonApiResource } from '@irian-ro/abstract-resource';
import { AccountStatusPaymentMethodStatusDto } from '@well/domain';

@Injectable({providedIn: "root"})
export class PaymentMethodPendingService{

  constructor(private paymentMethodResourceService: PaymentMethodResourceService) {
  }

  getPendingPaymentMethodStatus(): Observable<JsonApiResource<AccountStatusPaymentMethodStatusDto | null, any>>{
    return this.paymentMethodResourceService.getPendingPaymentMethodStatus();
  }

  unlinkPendingPaymentMethodFromAccountStatus(): Observable<unknown>{
    return <Observable<unknown>>this.paymentMethodResourceService.unlinkPendingPaymentMethodFromAccountStatus();
  }

  confirmPaymentMethod(): Observable<unknown>{
    return <Observable<unknown>>this.paymentMethodResourceService.confirmPaymentMethod();
  }

}
